<template>
    <div class="progress-bar__container">
        <div class="progress-bar-recorded" :class="colorClass" :style="fillWidth"></div>
        <div
            v-if="!alwaysShowFull || max === 0"
            class="progress-bar-forecasted"
            :class="max !== 0 && value > max ? colorClass : {}"
            :style="backgroundWidth"
        ></div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({
    components: {},
})
@AngularDirective('vrm-progress-bar')
export default class VrmProgressBar extends Vue {
    @Prop({ required: true })
    max;
    @Prop({ required: true })
    value;
    @Prop({ type: String })
    colorClass;
    @Prop({ type: Boolean, default: false })
    alwaysShowFull;

    get fillWidth() {
        if (this.alwaysShowFull && this.value < this.max) {
            return {
                width: '100%',
            };
        }
        return {
            width:
                this.max === 0
                    ? '0'
                    : (this.value <= this.max ? this.value / this.max : this.max / this.value) *
                          100 +
                      '%',
        };
    }

    get backgroundWidth() {
        if (this.alwaysShowFull) {
            return {
                width: '100%',
            };
        }
        return {
            width:
                (this.value <= this.max
                    ? this.max > 0
                        ? (this.max - this.value) / this.max
                        : 1
                    : (this.value - this.max) / this.value) *
                    100 +
                '%',
        };
    }
}
</script>
